import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { reportsAPI } from '../lib/api';

export default function WorkspaceReports() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    reportsAPI.workspace().then(({ data }) => setRows(data.projects));
  }, []);

  if (!rows) return null;

  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="mb-4 text-lg font-semibold">Workspace report</h1>
      <div className="overflow-x-auto rounded-lg border border-pm-border bg-pm-surface shadow-[var(--pm-elev-1)]">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-pm-border text-left text-xs text-pm-faint">
              <th className="px-3 py-2 font-medium">Project</th>
              <th className="px-3 py-2 text-right font-medium">Tasks</th>
              <th className="px-3 py-2 text-right font-medium">Done</th>
              <th className="px-3 py-2 text-right font-medium">Overdue</th>
              <th className="px-3 py-2 text-right font-medium">Hours</th>
              <th className="min-w-32 px-3 py-2 font-medium">Progress</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const pct = r.total_tasks ? Math.round((r.done_tasks / r.total_tasks) * 100) : 0;
              return (
                <tr key={r.project.id} className="border-b border-pm-border/50">
                  <td className="px-3 py-2.5">
                    <Link to={`/projects/${r.project.id}/report`} className="flex items-center gap-2 hover:text-pm-accent">
                      <span className="h-2.5 w-2.5 rounded-full" style={{ background: r.project.color }} />
                      {r.project.name}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5 text-right pm-num text-xs">{r.total_tasks}</td>
                  <td className="px-3 py-2.5 text-right pm-num text-xs">{r.done_tasks}</td>
                  <td className="px-3 py-2.5 text-right pm-num text-xs" style={r.overdue ? { color: 'var(--pm-danger)' } : {}}>
                    {r.overdue}
                  </td>
                  <td className="px-3 py-2.5 text-right pm-num text-xs">{(r.time_seconds / 3600).toFixed(1)}</td>
                  <td className="px-3 py-2.5">
                    <div className="h-1.5 overflow-hidden rounded-full bg-pm-raised">
                      <div className="h-full rounded-full" style={{ width: `${pct}%`, background: r.project.color }} />
                    </div>
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && (
              <tr>
                <td colSpan={6} className="px-3 py-10 text-center text-sm text-pm-muted">
                  No active projects.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
